<template>
  <div>
    <!--Modal de informações-->
    <vuestic-modal :show.sync="modal.show" ref="smallModal" v-bind:small="false" :cancelClass="'none'" okText="Fechar" cancelText="Fechar">
      <div slot="title">Informações</div>

      <div v-show="modal.load" >
        <div class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center">
          <div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
            <component
              :animation-duration="1000"
              :is="'SpringSpinner'"
              :color="'#4AE387'"
              :size="80"
            >
            </component>
          </div>
        </div>
      </div>
      <div v-show="!modal.load">
        <vuestic-tabs :names="['Dados Básicos']" ref="tabs">
          <div slot="Dados Básicos">
            <div class="row">
              <div class="col-md-6 text-center">
                <strong class="font-weight-bold">Usuário:</strong><br>
                {{modal.conteudo.cam_user}}
              </div>
              <div class="col-md-6 text-center">
                <strong class="font-weight-bold">Senha:</strong><br>
                {{modal.conteudo.cam_pass}}
              </div>
            </div>
            <!--<strong>Situação:</strong>-->
          </div>
        </vuestic-tabs>
      </div>
    </vuestic-modal>
    <!--Botões da paginação-->

    <!--Legenda com barra de pesquisa-->
    <div class="row">
      <div class="col-md-9">
        <router-link :to="{name: 'nova-cam'}" href="#"><button class="btn btn-primary" id="btn" type="button">Nova câmera</button></router-link>
      </div>
      <div class="col-md-3">
        <fieldset>
          <div class="form-group with-icon-left">
            <div class="input-group">
              <input @input="debounceInput" id="search" autocomplete="off" required>
              <label class="control-label" for="search">Procurar...</label><i class="bar"></i>
              <i class="fa icon-left input-icon fa-search"></i>
            </div>
          </div>
        </fieldset>
      </div>
    </div>
    <!--Legenda com barra de pesquisa-->
    <!--Botões da paginação-->
    <div class="row">
      <div class="col mx-auto">
        <nav>
          <ul class="pagination justify-content-center">
            <li class="page-item disabled" id="previous_page" v-show="table.currentPage == 1">
              <a class="page-link" href="#" tabindex="-1">Anterior</a>
            </li>
            <li class="page-item" id="previous_page" @click.stop="previousPage()" v-show="table.currentPage != 1">
              <a class="page-link" href="#" tabindex="-1">Anterior</a>
            </li>                                      
            <template v-for="(page, index) in table.pages">
              <li class="page-item" v-show="page !== table.currentPage" @click="page === table.currentPage ? null : pagePaginate(page)" :key="index + page + 'age'"> 
                <a class="page-link" @click.prevent="page === table.currentPage ? null : pagePaginate(page)" href="#" >{{ page }}</a>
              </li>
              <li class="page-item active" v-show="page === table.currentPage"  :key="index"> 
                <a class="page-link"  href="#" >{{ page }}</a>
              </li>
            </template>            
            <li class="page-item disabled" id="previous_page" v-show="table.lastPage == table.currentPage">
              <a class="page-link" href="#" tabindex="-1">Próximo</a>
            </li>
            <li class="page-item" id="previous_page" @click.stop="nextPage()" v-show="table.lastPage != table.currentPage">              
              <a class="page-link" href="#" tabindex="-1">Próximo</a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
    <!--Botões da paginação-->
    <!--Tabela-->
    <div class="row">
      <div class="col-md-12">
        <table class="table table-responsive-sm">
          <thead>
          <tr>
            <th v-for="th in tableOptions.thead" :key="th"  scope="col">{{th}}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-show="table.load">
            <td colspan="6" class="text-center">
              <div class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center">
                <div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
                  <component
                    :animation-duration="1000"
                    :is="'SpringSpinner'"
                    :color="'#4AE387'"
                    :size="80"
                  >
                  </component>
                </div>
              </div>
            </td>
          </tr>
          <tr v-show="!table.load" v-for="dados in table.data" class="tb-linha" :key="dados.id_cam">
            <td>{{dados.cam_address}}</td>
            <td>{{dados.id_sala}}</td>
            <td>
              <button title="Ver informações da câmera" class="btn btn-primary btn-with-icon rounded-icon btn-micro" @click="detalhes(dados.id_cam)">
                <span aria-hidden="true" class="fa fa-info" style="font-size: 16px;"></span></button>
              <button title="Câmera sala" class="btn btn-primary btn-with-icon rounded-icon btn-micro text-white" @click="paginaEdicao(dados.id_cam)">
                <span aria-hidden="true" class="fa fa-edit" style="font-size: 16px;"></span></button>
            </td>
          </tr>
          <tr v-show="table.data.length === 0 && !table.load">
            <td colspan="6" class="text-center">Nenhum registro encontrado.</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
      <!--Botões da paginação-->
      <div class="row">
        <div class="col mx-auto">
          <nav>
            <ul class="pagination justify-content-center">
              <li class="page-item disabled" id="previous_page" v-show="table.currentPage == 1">
                <a class="page-link" href="#" tabindex="-1">Anterior</a>
              </li>
              <li class="page-item" id="previous_page" @click.stop="previousPage()" v-show="table.currentPage != 1">
                <a class="page-link" href="#" tabindex="-1">Anterior</a>
              </li>                                      
              <template v-for="(page, index) in table.pages">
                <li class="page-item" v-show="page !== table.currentPage" @click="page === table.currentPage ? null : pagePaginate(page)" :key="index + page + 'age'"> 
                  <a class="page-link" @click.prevent="page === table.currentPage ? null : pagePaginate(page)" href="#" >{{ page }}</a>
                </li>
                <li class="page-item active" v-show="page === table.currentPage"  :key="index"> 
                  <a class="page-link"  href="#" >{{ page }}</a>
                </li>
              </template>            
              <li class="page-item disabled" id="previous_page" v-show="table.lastPage == table.currentPage">
                <a class="page-link" href="#" tabindex="-1">Próximo</a>
              </li>
              <li class="page-item" id="previous_page" @click.stop="nextPage()" v-show="table.lastPage != table.currentPage">              
                <a class="page-link" href="#" tabindex="-1">Próximo</a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <!--Botões da paginação-->
    <!--Tabela-->
  </div>
</template>

<script>
  import CamsController from './CamsController'
  import * as spinners from 'epic-spinners'
  import urlApi from '../../router/urlApi'
  window._ = require('lodash')

  export default {
    name: 'TableCams',
    components: {
      ...spinners
    },
    data () {
      return {
        modal: {
          show: false,
          load: false,
          conteudo: {}
        },
        url: urlApi + '/aulas/cameras/paginacao',
        tableOptions: { 'thead': ['Câmera', 'Sala', '-'] },
        search: '',
        table: {
          currentPage: '',
          data: '',
          firstPageUrl: '',
          from: '',
          lastPage: '',
          lastPageUrl: '',
          nextPageUrl: '',
          path: '',
          perPage: '',
          prevPageUrl: '',
          to: '',
          total: '',
          pages: [],
          load: true
        }
      }
    },
    mounted () {
      this.loadData()
    },
    methods: {
      callbackDataPaginate (response) {
        let responseData = response.data
        this.table.currentPage = responseData.current_page
        this.table.data = responseData.data
        this.table.firstPageUrl = responseData.first_page_url
        this.table.from = responseData.from
        this.table.lastPage = responseData.last_page
        this.table.lastPageUrl = responseData.last_page_url
        this.table.nextPageUrl = responseData.next_page_url
        this.table.path = responseData.path
        this.table.perPage = responseData.per_page
        this.table.prevPageUrl = responseData.prev_page_url
        this.table.to = responseData.to
        this.table.total = responseData.total

        this.table.pages = []
        for (let i = 1; i <= (responseData.last_page); i++) {
          this.table.pages.push(i)
        }

        this.items = this.table.data

        this.table.load = false;

      },
      nextPage () {
        this.table.load = true      
        this.$http.get(this.table.nextPageUrl + '&search=' + this.search ).then(this.callbackDataPaginate)
      },
      previousPage () {
        this.table.load = true
        this.$http.get(this.table.prevPageUrl + '&search=' + this.search ).then(this.callbackDataPaginate)
      },
      loadData () {
        this.table.load = true
        this.$http.get(this.url + '?search=' + this.search).then(this.callbackDataPaginate)
      },
      pagePaginate (page) {
        this.table.load = true
        this.$http.get(this.url + '?search=' + this.search + '&page=' + page).then(this.callbackDataPaginate)
      },
      debounceInput: _.debounce(function (e) {
        this.search = e.target.value
        this.loadData()
      }, 1000),

      detalhes: function (idCam) {
        let self = this
        this.$refs.smallModal.open()
        self.modal.load = true
        CamsController.getCamById(idCam, function (response) {
          self.modal.conteudo = response.data.dados
          self.modal.load = false
        })
      },

      paginaEdicao (idCam) {
        CamsController.paginaEdicao(idCam)
      }
    }
  }
</script>

<style type="text/css" scoped>
  .tb-opcoes {
    display: block;
    position: absolute;
    right: 20px;
    margin-top:-8px;
  }
  .tb-linha:hover .tb-opcoes {
    display: block;
  }

  @media (max-width: 1200px) {
    .tb-opcoes {
      display: block;
    }
  }
  .circle {
    width: .75rem;
    height: .75rem;
    border-radius: 50%;
    display: inline-block;
  }
</style>
